var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQr = function SvgQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.375 13.125h-11.25v11.25h11.25v-11.25Zm-15-3.75v18.75h18.75V9.375H9.375Zm15 26.25h-11.25v11.25h11.25v-11.25Zm-15-3.75v18.75h18.75v-18.75H9.375Zm26.25-18.75h11.25v11.25h-11.25v-11.25Zm-3.75 15V9.375h18.75v18.75h-18.75Zm0 15v-11.25h3.75v11.25h-3.75Zm-15-26.25v3.75h3.75v-3.75h-3.75Zm0 26.25v-3.75h3.75v3.75h-3.75Zm22.5-26.25v3.75h3.75v-3.75h-3.75Zm7.5 33.75V45h3.75v5.625h-3.75Zm0-18.75V37.5h-3.75v-5.625h-3.75v15h-7.5v3.75h11.25V41.25h7.5v-9.375h-3.75Z",
    fill: "#1D1737"
  })));
};
export default SvgQr;